/**
 * @desc 表格列显示与隐藏控制按钮
 * @props typeId         表格的类型
 * @props notArr         接口数组中不需要的项
 * @props originalArr    表格的全部列数组
 * @props delayQuery     是否延迟请求接口，在需要的时候请求，如否，则会在组件将挂载的时候请求接口
 * @props changeCb       选择项change的时候的回调
 */
import React, { Component } from 'react';
import { dispatch } from '@@/store';
import { connect } from 'react-redux';
import { Button, Dropdown, Checkbox, Menu, message, Icon } from 'antd';
import styled from 'styled-components';
const Root = styled.div `
  .ant-checkbox-inner {
    border-radius: 50%;
  }
`;
const mapStateToProps = (rootState) => ({
    _state: rootState.columnShow,
    _userInfo: rootState.columnShow,
});
class ColumnShow extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            visible: false,
            timeout: 0,
        };
        this.queryColumn = () => {
            const { typeId, notArr, originalArr } = this.props;
            dispatch.columnShow.queryShowColumn({ typeId, notArr, originalArr });
        };
        this.handleVisibleChange = (flag) => {
            this.setState({ visible: flag });
        };
        this.onChange = (e) => {
            const { changeCb } = this.props;
            const { value, checked } = e.target;
            const { options } = this.props._state;
            const arr = JSON.parse(JSON.stringify(options));
            const _i = arr.findIndex((_item) => (_item.code === value));
            _i === -1 ? '' : arr[_i].isView = Number(checked);
            /** 至少选中一项，否则提示 */
            if (arr.every((_item) => (_item.isView === 0))) {
                message.warning('请至少选择一项展示');
                return;
            }
            /** 保存数据 */
            this.saveColumn({ arr, time: 500 });
            /** 更新显示 */
            dispatch.columnShow.SET_STATE({ options: arr });
            /** 回调 */
            changeCb ? changeCb(arr) : '';
        };
        this.saveColumn = ({ time, arr }) => {
            const { timeout } = this.state;
            if (timeout) {
                clearTimeout(timeout);
            }
            const _timeout = setTimeout(() => {
                const { typeId } = this.props;
                const { notNeedOptions } = this.props._state;
                dispatch.columnShow.saveShowColumn({ typeId, arr: arr.concat(notNeedOptions) });
            }, time);
            this.setState({ timeout: _timeout });
        };
        this.getMenu = () => {
            const { options } = this.props._state;
            return (<Menu multiple={true}>
        {options.map((item, i) => (<Menu.Item key={`c_m_${i}`}>
            <Checkbox value={item.code} checked={item.isView === 1} onChange={this.onChange}>{item.name}</Checkbox>
          </Menu.Item>))}
      </Menu>);
        };
    }
    componentWillMount() {
        const { delayQuery, _userInfo } = this.props;
        if (!delayQuery) {
            if (_userInfo.user.tenantCode) {
                this.queryColumn();
            }
            else {
                setTimeout(() => {
                    this.queryColumn();
                }, 500);
            }
        }
    }
    render() {
        const menu = this.getMenu();
        return (<Root>
        <Dropdown overlay={menu} onVisibleChange={this.handleVisibleChange} visible={this.state.visible} getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
          <Button>
            <Icon type="eye" style={{ fontSize: '16px' }}/>
            显示
          </Button>
        </Dropdown>
      </Root>);
    }
}
export default connect(mapStateToProps)(ColumnShow);
